// This will be caught by an <ErrorBoundary /> component
import {ERRORS, LAYOUT_IDS} from 'Utils/constants';

export default layoutId => {
    if (!Object.values(LAYOUT_IDS).includes(layoutId)) {
        throw Error(ERRORS.INVALID_SIGN_DATA);
    }
};
